import router from '@/router';

interface IModalMenu {
	menu: 'More' | 'Search' | 'Notification' | 'Interest' | 'Country';
}
export const openMenuModal = ({ menu }: IModalMenu) => {
	const currentRoute = router.currentRoute.value;

	// 새로운 쿼리 객체 생성
	const newQuery: Record<string, string> = {};

	// 기존 쿼리 파라미터 순회
	Object.keys(currentRoute.query).forEach((key) => {
		// 다른 메뉴 오픈 상태 쿼리는 모두 제거
		if (!key.startsWith('is') || !key.endsWith('MenuOpen')) {
			const value = currentRoute.query[key];

			if (value !== null && value !== undefined) {
				if (Array.isArray(value)) {
					newQuery[key] = String(value[0] ?? '');
				} else {
					newQuery[key] = String(value);
				}
			}
		}
	});

	// 새로운 메뉴 오픈 상태 쿼리 추가
	newQuery[`is${menu}MenuOpen`] = 'true';

	document.body.classList.add('hidden');

	router.push({
		query: newQuery,
	});
};

export const closeMenuModal = () => {
	const currentRoute = router.currentRoute.value; // 현재 경로 가져오기
	const updatedQuery = { ...currentRoute.query };

	// 특정 메뉴 관련 쿼리를 제거
	Object.keys(updatedQuery).forEach((key) => {
		if (key.startsWith('is') && key.endsWith('MenuOpen')) {
			delete updatedQuery[key];
		}
	});

	document.body.classList.remove('hidden');
	router.push({
		query: updatedQuery, // 수정된 쿼리 적용
	});
};
